import { gql } from "graphql-request";

export const getOrganisationtype = gql`
  query organisationtype($organization: String!) {
    getOrganisationtype(organizationType: $organization) {
      id
      firstName
      organizationName
    }
  }
`;
export const getContactdetail = gql`
  query filtername($id: String!) {
    getContactdetail(id: $id) {
      role

      organizationName

      contactNumber
    }
  }
`;
export const getUserHierarchy = gql`
  query getUserHierarchy($id: Int!) {
    getUserHierarchy(id: $id) {
      id
      username
    }
  }
`;
export const allCalldetails = gql`
  query {
    allCalldetails {
      id
      clgid
      organization
      name
      phoneNo
      callstartDate
      callstartTime
      createdAt
      user {
        username
      }
    }
  }
`;
export const getcalldetails = gql`
  query getcalldetails($id: String!) {
    getCalldetailsById(id: $id) {
      id
      userType
      name
      role
      organization
      phoneNo
      prefferedBy {
        id
        username
      }
      task{
        id
        title
      }
      callstartDate
      callType
      callstartTime
      callDuration
      callDescription
    }
  }
`;
export const getuser = gql`
  query filterdetails($id: String) {
    getContactdetail(id: $id) {
      mailId
    }
  }
`;

export const getAllTask = gql`
query { 
    allTasks {  
      success   
      message  
      data {   
        id 
        title 
        status  
        deadlineDate 
        assignedTo { 
          id 
          username 
        } 
      } 
    } 
}`;

export const allContact = gql`
  query {
    allContact {
      id
      firstName
      lastName
      organizationId
      organizationName
      organizationType
      role
      contactNumber
      mailId
      user {
        username
      }
    }
  }
`;
export const allCustomer = gql`
  query {
    allCustomer {
      id
      legalName
      user {
        username
      }
    }
  }
`;
export const allLeadprospect = gql`
  query {
    allLeadprospect {
      user {
        id

        username

        masterId
      }

      id
      companyName
      firstName
    }
  }
`;
export const allVendor = gql`
  query {
    allVendor {
      user {
        id
        username
      }
      id
      legalName
    }
  }
`;
export const getContactdetailByMaster = gql`
  query getContactdetailByMaster($id: String!) {
    getContactdetailByMaster(id: $id) {
      id
      firstName
      lastName
      organizationName
      organizationType
      organizationId
      contactNumber
      role
      mailId
      user {
        username
      }
    }
  }
`;
export const getContactdetailByUser = gql`
  query getContactdetailByUser($id: String!) {
    getContactdetailByUser(id: $id) {
      id
      firstName
      lastName
      organizationId
      organizationName
      contactNumber
      organizationType
      role
      mailId
      organizationId
      user {
        username
      }
    }
  }
`;
export const getCustomerByMaster = gql`
  query getCustomerByMaster($id: String!) {
    getCustomerdetailByMaster(id: $id) {
      id
      legalName
      user {
        username
      }
    }
  }
`;
export const getCustomerByUser = gql`
  query getCustomerByUser($id: String!) {
    getCustomerdetailByUser(id: $id) {
      id
      legalName
      user {
        username
      }
    }
  }
`;
export const getLeadProspectByMaster = gql`
  query getLeadProspectByMaster($id: String!) {
    getLeadprospectDetailByMaster(id: $id) {
      user {
        id

        username

        masterId
      }

      id
      companyName
      firstName
    }
  }
`;
export const getLeadProspectByUser = gql`
  query getLeadProspectByUser($id: String!) {
    getLeadprospectDetailByUser(id: $id) {
      user {
        id

        username

        masterId
      }

      id
      companyName
      firstName
    }
  }
`;
export const getVendorByMaster = gql`
  query getVendorByMaster($id: String!) {
    getVendordetailByMaster(id: $id) {
      user {
        id
        username
      }
      id
      legalName
    }
  }
`;
export const getVendorByUser = gql`
  query getVendorByUser($id: String!) {
    getVendordetailByUser(id: $id) {
      user {
        id
        username
      }
      id
      legalName
    }
  }
`;
export const getAppointmentDetailByMaster = gql`
  query getAppointmentByMaster($id: String!) {
    getAppointmentDetailByMaster(id: $id) {
      id
      scheduledDate
      time
      appoinmentWith
      withName
      contactPerson
      name
      email
      phoneNumber
      status
      description
      user {
        username
      }
    }
  }
`;
export const getAppointmentDetailByUser = gql`
  query getAppointmentByUser($id: String!) {
    getAppointmentDetailByUser(id: $id) {
      id
      scheduledDate
      time
      appoinmentWith
      withName
      contactPerson
      name
      email
      phoneNumber
      status
      description
      user {
        username
      }
    }
  }
`;

export const allAppointment = gql`
  query {
    allAppointment {
      id
      scheduledDate
      time
      appoinmentWith
      withName
      contactPerson
      name
      email
      phoneNumber
      status
      description
      user {
        username
      }
    }
  }
`;

export const allWhatsapp = gql`
query {
  allWhatsappLogs {
    success
    error
    message
    data {
      id
      task {
        title
      }
      assignedTo {
        username
      }
      chatDate
      chatstartTime
      chatendTime
      duration
      outcome
      followUpActions
      createdAt
    }
  }
}`;

export const allVisit = gql`
query {
    allVisit {
      id
      vlgid
      visiteddate
      time
      contactPerson
      phoneNumber
      createdAt
      user {
        username
      }
    }
  }
`;
export const getvisitdetails = gql`
  query getvisitdetails($id: String!) {
    getVisitById(id: $id) {
      id
      visiteddate
      time
      visitedwith
      withName
      contactPerson
      name
      email
      phoneNumber
      description
      task{
        id
        title
      }
      visitappoinmentSet {
        id
        visitedPerson {
          id
          username
        }
      }
    }
  }
`;
export const allEmaildetails = gql`
  query {
    allEmaildetails {
      id
      malid
      organisationName
      name
      fromEmail
      toEmail
      createdAt
      user {
        username
      }
    }
  }
`;
export const getEmaildetailsById = gql`
  query getemaildetails($id: String!) {
    getEmaildetailsById(id: $id) {
      id
      userType
      organisationName
      name
      preparedBy {
        username
      }
      fromEmail
      toEmail
      title
      emailType
      emailPurpose
      emailDescription
      fileattachment
      task{
        id
        title
      }
    }
  }
`;
export const getUserDetail = gql`
  query getuser($id: String!) {
    getUserDetail(id: $id) {
      email
    }
  }
`;
export const allprospect = gql`
  query {
    allLeadprospect {
      id

      companyName
    }
  }
`;
export const allCustomers = gql`
  query {
    allCustomer {
      id
      legalName
    }
  }
`;
export const getOrganisationname = gql`
  query filterorganisationname($organisationname: String!) {
    getOrganisationname(organizationName: $organisationname) {
      id

      firstName
    }
  }
`;
export const getContactdetails = gql`
  query filterdetails($id: String) {
    getContactdetail(id: $id) {
      role
      contactNumber
    }
  }
`;
